import '../index.css';
var styles = {
  "contentFieldWrapper": "bp_content_field_module_contentFieldWrapper--dabac",
  "contentField": "bp_content_field_module_contentField--dabac",
  "inlineError": "bp_content_field_module_inlineError--dabac",
  "contentButton": "bp_content_field_module_contentButton--dabac",
  "error": "bp_content_field_module_error--dabac",
  "hasSelection": "bp_content_field_module_hasSelection--dabac",
  "contentIconContainer": "bp_content_field_module_contentIconContainer--dabac",
  "contentIconShared": "bp_content_field_module_contentIconShared--dabac",
  "contentLabelWrapper": "bp_content_field_module_contentLabelWrapper--dabac",
  "contentLabel": "bp_content_field_module_contentLabel--dabac",
  "clearButton": "bp_content_field_module_clearButton--dabac"
};
export { styles as default };